module.exports = __webpack_public_path__ + "static/media/7up7down.c0c56dd2.png";